import { render, staticRenderFns } from "./spline-c3.vue?vue&type=template&id=0fd94adb"
import script from "./spline-c3.vue?vue&type=script&lang=js"
export * from "./spline-c3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports